var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    width: 26,
    height: 25,
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0, 0, 0)"
    },
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.013 24.991c-.496 0-1.034-.145-1.597-.427a3.393 3.393 0 0 1-1.636-1.818 19.494 19.494 0 0 1-.784-2.57c-.36-1.578-1.657-4.101-2.941-5.191-.699-.595-1.101-1.493-1.101-2.464V5.046c0-.864.292-1.715.83-2.395C9.043 1.039 10.178.175 11.153.077c1.593-.163 7.453-.013 7.881 0 .246-.009 1.551.038 2.31 1.424.601 1.095 3.805 6.834 3.941 7.078.368.662.597 1.364.673 2.091.11 1.039.055 2.493-.83 3.523-.619.727-1.534 1.121-2.721 1.172-3.089.133-4.779.056-5.351.017.114.719.368 2.515.75 5.363.11.83 0 1.655-.322 2.386-.386.877-.958 1.476-1.657 1.728a2.178 2.178 0 0 1-.814.132Zm1.983-9.942ZM4.326 15.13H1.581A1.59 1.59 0 0 1 0 13.535V3.327a1.59 1.59 0 0 1 1.581-1.595h2.745a1.59 1.59 0 0 1 1.581 1.595v10.212c0 .877-.708 1.595-1.581 1.591Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(229, 35, 27)"
    },
    className: "fills"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike2);
export default __webpack_public_path__ + "static/media/dislike_2.f796e469549678d1d44571d2cfe1756d.svg";
export { ForwardRef as ReactComponent };